import ChartConfiguration from "./ChartConfiguration";

const ChartTab = () => <ChartConfiguration />;

export default ChartTab;
